import React, { useEffect, useState } from "react";
import { useForm } from '@mantine/form';
import { useDispatch, useSelector } from "react-redux";
import { useDisclosure } from "@mantine/hooks";
import { Container, Group, Grid,Text } from '@mantine/core';
import { getManualBySiteId } from "../../../store/manageSite/actions";
import { onAddnewManual } from "../../../store/manageSite/actions";
import virginmedia from '../../../assets/images/virginmedia.png';
import jbassociate from '../../../assets/images/jb-associate.png';
import jblogodarkarrow from '../../../assets/images/jb-dark.svg';
import jbdoorimage from '../../../assets/images/manuals-default.png';
import MantineTextInput from "../../../components/mantine/textinput";
import MantineButton from "../../../components/mantine/button";
import ManualCard from '../../../components/common/manualbox';
import CustomModalHeaderTitle from "../../../components/common/customModalHeaderTitle";
import { MantineModal } from "../../../components/mantine/modal";
import EditManualUrl from './edit';
import DeleteConfirmation from "./delete";
import { useParams } from 'react-router-dom';
import { fetchAllSites } from "../../../store/actions";

const ManualAction = () => {
    const [urls, setUrls] = useState<any[]>([]);
    const [selectedRows, setSelectedRows] = useState<any>(null);
    const [openedUpdateURL, { open: openUpdatePopUp, close: closeUpdatePopUp }] = useDisclosure(false);
    const [openedDeletePopUp, { open: openDeletePopUp, close: closeDeletePopUp }] = useDisclosure(false);

    const dispatch = useDispatch();
    const form = useForm({
        initialValues: {
            manualurl: '',
            manualname: ''
        },
        validate: {
            manualurl: (value) => {
                const regex = new RegExp(
                    /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/
                );
                return value  ? regex.test(value)  ? null : 'Please enter a valid URL'   : 'URL is required'; 
              },
                    
            manualname: (value) => (value ? null : 'Manual Name is required'),
        },
    });
    const { getmanual } = useSelector((state: any) => ({
        getmanual: state?.getManualURL?.Manualbysite,
    }));

    const { siteId } = useParams();
    const clientId = typeof window !== 'undefined' ? localStorage.getItem('SitebyClientId') : null;

    useEffect(() => {
        if (siteId) {
            dispatch(getManualBySiteId({ siteId }));
        }
    }, [dispatch, siteId]);

    useEffect(() => {
        if (getmanual) {
            setUrls(getmanual);
        }
    }, [getmanual]);

    const handleResponseManualForm = (status: any) => {
        if (status === "SUCCESS" || status === "ADD SUCCESS") {
            dispatch(getManualBySiteId({ siteId }));
        }
    };

    const handleSubmit = (values: any) => {
        if (values.manualurl && values.manualname) {
            dispatch(onAddnewManual({ siteId, clientId, url: values.manualurl, manualName: values.manualname }, handleResponseManualForm));
            form.reset();
        }
    };
    const closeUpdateUrl = () => {
        closeUpdatePopUp();
        dispatch(getManualBySiteId({ siteId }));
    };

    const closeDelete = () => {
        closeDeletePopUp();
        dispatch(getManualBySiteId({ siteId }));
    };

    useEffect(() => {
        dispatch(fetchAllSites())
    }, [])
  
    return (
        <Container size="xl" my="xl" className='max-w-[1240px] w-full'>
            <form onSubmit={form.onSubmit(handleSubmit)}>
                <Group className='flex-row flex-1'>
                    <MantineTextInput
                        placeholder="Enter URL"
                        value={form.values.manualurl}
                        onChange={(e: any) => form.setFieldValue('manualurl', e.currentTarget.value)}
                        classNames={{ input: 'w-[363px] h-[40px] bg-white border border-gray-400 rounded-[40px] opacity-100' }}
                        error={form.errors.manualurl}
                    />
                    <MantineTextInput
                        placeholder="Enter Manual Name"
                        value={form.values.manualname}
                        onChange={(e: any) => form.setFieldValue('manualname', e.currentTarget.value)}
                        classNames={{ input: 'w-[363px] h-[40px] bg-white border border-gray-400 rounded-[40px] opacity-100' }}
                        error={form.errors.manualname}

                    />
                    <MantineButton
                        type="submit"
                        className="w-[140px] h-[40px] bg-[#2F7FE2] rounded-[40px] opacity-100 text-sm font-thin text-white"
                        style={{ fontFamily: 'Gantari, sans-serif', fontWeight: 'bold', fontSize: '14px', lineHeight: '16px' }}
                    >
                        SUBMIT
                    </MantineButton>
                </Group>
            </form>

            <Grid className='mt-8'>
                {urls.length > 0 ? (
                    urls.map((urlData, index) => (
                        <Grid.Col span={4} key={index}>
                            <ManualCard
                                number={index + 1}
                                manualname={urlData.manualName}
                                virginImage={virginmedia}
                                jbAssociateImage={jbassociate}
                                doorImage={jbdoorimage}
                                arrowImage={jblogodarkarrow}
                                showedit={true}
                                showdownload={false}
                                handleEdit={() => {
                                    setSelectedRows(urlData);
                                    openUpdatePopUp();
                                }}
                                handleDelete={() => {
                                    setSelectedRows(urlData);
                                    openDeletePopUp();
                                }}
                                item={urlData}
                            />
                        </Grid.Col>
                    ))
                ) : (
                    <Grid.Col span={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Text className="no-drawing-message">No manuals found for the selected site.</Text>
                    </Grid.Col>
                )}
            </Grid>

            <MantineModal opened={openedUpdateURL} onClose={closeUpdatePopUp} title={<CustomModalHeaderTitle title='Edit Url' onClick={closeUpdatePopUp} />}>
                <EditManualUrl
                    clientId={clientId}
                    manualData={selectedRows}
                    modalclose={closeUpdatePopUp}
                    dispatch={dispatch}
                    handleEdit={closeUpdateUrl}
                />
            </MantineModal>
            <MantineModal opened={openedDeletePopUp} onClose={closeDeletePopUp} title={<CustomModalHeaderTitle title='Delete' onClick={closeDeletePopUp} />}>
                <DeleteConfirmation
                    manualData={selectedRows}
                    modalclose={closeDeletePopUp}
                    handleDelete={closeDelete}
                />
            </MantineModal>
        </Container>
    );
};

export default ManualAction;
